import { Breadcrumb } from 'antd';
import { LayoutCMS } from 'components';
import React from 'react';
import { Link } from 'react-router-dom';
import TableLandingPage from './libraries';

export const PageLandingPageComponent = (props: any) => {
    const title = 'Landing Page';
    const layoutCMSProps = {
        breadcrumb: (
            <>
                <Breadcrumb.Item>
                    <Link to="/article/landing-page">Landing Page</Link>
                </Breadcrumb.Item>
            </>
        ),
        documentTitle: title,
        history: props.history,
        pageTitle: title,
    };
    return (
        <LayoutCMS {...layoutCMSProps}>
            <TableLandingPage />
        </LayoutCMS>
    );
};

export default PageLandingPageComponent;



// WEBPACK FOOTER //
// ./src/pages/landing-page/component.tsx